import React from 'react';

const Loading = () => {
  return (
    <div className="loading-container">
      <div className="spinner"></div>
      <p>Loading content, please wait...</p>
    </div>
  );
};

export default Loading;
